import { Component, computed, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseItemComponent } from '../../common-items/BaseItem/base-item-form.component';
import { BaseItemProperties, DEFAULT_BASE_PROPERTIES } from '../../common-items/BaseItem/base-item-properties';

import { getPropsFrom } from '@lfw/roesberg.liveforms.core';

interface ImageItemProperties {
  base64String: string;
  stretchOption: string;
  addedWhileProcessing: string;
  imageWidth: number;
  imageHeight: number;
  scale: number;
}

@Component({
  selector: 'lfe-image-item-form',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './image-item-form.component.html',
  standalone: true,
  styleUrl: './image-item-form.component.css'
})
export class ImageItemFormComponent extends BaseItemComponent<ImageItemProperties> implements OnInit {
  properties: BaseItemProperties & ImageItemProperties = {
    ...DEFAULT_BASE_PROPERTIES,
    base64String: '',
    stretchOption: 'normal',
    addedWhileProcessing: 'False',
    imageWidth: 0,
    imageHeight: 0,
    scale: 1
  };

  scale = signal(1);

  src = computed(() => (this.properties.base64String ? `data:image/png;base64,${this.properties.base64String}` : ''));

  alt = computed(() => `Image ${this.currentId()}`);

  imageSize = computed(() => ({
    width: Math.round(this.properties.imageWidth * this.scale()),
    height: Math.round(this.properties.imageHeight * this.scale())
  }));

  currentId = computed(() => this.properties.customId || this.properties.id);
  htmlId = computed(() => `image_${this.currentId()}`);

  override ngOnInit() {
    super.ngOnInit();
    this.scale.set(this.properties.scale);
  }

  extractLocalProperties(xml: Element): BaseItemProperties & ImageItemProperties {
    const props = getPropsFrom(xml);

    const parsedScale = props['Scale'] ? props['Scale'].replaceAll('.', '').replaceAll(',', '.') : '1';

    const id = props['ID'] || '';
    const customId = props['CustomID'] || '';
    const activationRule = props['ActivationRule'] || '';
    const addedWhileProcessing = props['AddedWhileProcessing'] || 'False';
    const base64String = props['Base64String'] || '';
    const imageHeight = Number(props['ImageHeight'] || 0);
    const imageWidth = Number(props['ImageWidth'] || 0);
    const isGenericRepeatItem = props['IsGenericRepeatItem'] === 'True';
    const stretchOption = props['StretchOption'] || 'normal';
    const scale = Number(parsedScale) || 1;

    return {
      ...DEFAULT_BASE_PROPERTIES,
      id,
      customId,
      activationRule,
      base64String,
      stretchOption,
      addedWhileProcessing,
      imageWidth,
      imageHeight,
      scale,
      isGenericRepeatItem
    };
  }

  onScaleChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = Number(input.value);
    this.scale.set(value);
    this.properties.scale = value;
  }
}
